module.exports = __webpack_public_path__ + "static/pn-a2911b5bcb5c1de039d507eb27ea7615.svg";